import React, { Component } from 'react';
import { SelectDividerProps } from 'ui/form/fields';

interface SelectDividerState {}
export default class SelectDivider extends Component<SelectDividerProps, SelectDividerState> {
  render() {
    const { label } = this.props;
    if (label) {
      return <small className="list-header">{label}</small>;
    }

    return <div style={{ borderBottom: '1px solid rgba(255,255,255,0.7)' }} />;
  }
}
